var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM11.9999 4.64716L18.6495 11.2092C19.0257 11.5805 19.0231 12.1886 18.6436 12.5565C18.2758 12.9131 17.6904 12.9105 17.3258 12.5506L13.0136 8.29524L13.0136 18.6244C13.0136 19.1853 12.5589 19.64 11.998 19.64C11.4371 19.64 10.9824 19.1853 10.9824 18.6244L10.9824 8.29907L6.67412 12.5506C6.30948 12.9105 5.72414 12.9131 5.35633 12.5565C4.97684 12.1886 4.97415 11.5805 5.35037 11.2092L11.9999 4.64716Z",
    fill: "#393D47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleUp);
export default __webpack_public_path__ + "static/media/circleUp.eee7a983fa758a4ee4d84026a0a25d1a.svg";
export { ForwardRef as ReactComponent };